<template>
  <CustomModal
    class="export-data-modal"
    :is-modal-open="isOpen"
    @toggleModal="emit('closeModal')"
    @onClickAway="emit('closeModal')"
    :overlay="'dark'"
    :with-header="true"
    :with-footer="true"
    custom-classes="tw:h-screen tw:md:h-auto tw:w-[100vw] tw:md:max-w-[636px] tw:md:w-[636px] tw:md:rounded-md tw:rounded-none"
  >
    <template #modalHeader
      ><p class="tw:text-xl">{{ $t(modalTitle) }}</p></template
    >

    <div class="tw:flex tw:flex-col">
      <div class="tw:mx-auto tw:mb-6">
        <img :src="getImage('web')" :alt="$t(modalTitle)" class="tw:max-h-[320px] tw:hidden tw:md:flex" />
        <img :src="getImage('mobile')" :alt="$t(modalTitle)" class="tw:max-h-[320px] tw:md:hidden tw:flex" />
      </div>
      <p class="tw:pb-6" v-html="$t('rc_opportunities_top_position_info')" />
    </div>

    <template #modalFooter>
      <div class="tw:flex tw:w-full tw:justify-end">
        <MainButton size="medium" @click="emit('closeModal')">{{ $t('rc_opportunities_cta_close') }}</MainButton>
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import { computed } from 'vue'

import CustomModal from '@/components/base/CustomModal.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'

import { useSessionValues } from '@/composables/useSessionValues'

const emit = defineEmits(['closeModal'])
defineProps({ isOpen: Boolean })

const { language } = useSessionValues()
const langCode = computed(() => {
  const locale = language.value || 'en-US'
  return locale.split('-')[1].toLowerCase()
})

const WEB_IMAGES = {
  us: new URL('/src/assets/img/opportunity-area/learn-more-web-us.png', import.meta.url),
  de: new URL('/src/assets/img/opportunity-area/learn-more-web-de.png', import.meta.url),
  br: new URL('/src/assets/img/opportunity-area/learn-more-web-br.png', import.meta.url),
  gr: new URL('/src/assets/img/opportunity-area/learn-more-web-el.png', import.meta.url),
  es: new URL('/src/assets/img/opportunity-area/learn-more-web-es.png', import.meta.url),
  fr: new URL('/src/assets/img/opportunity-area/learn-more-web-fr.png', import.meta.url),
  mx: new URL('/src/assets/img/opportunity-area/learn-more-web-mx.png', import.meta.url),
  it: new URL('/src/assets/img/opportunity-area/learn-more-web-it.png', import.meta.url),
  jp: new URL('/src/assets/img/opportunity-area/learn-more-web-ja.png', import.meta.url),
  nl: new URL('/src/assets/img/opportunity-area/learn-more-web-nl.png', import.meta.url),
  pl: new URL('/src/assets/img/opportunity-area/learn-more-web-pl.png', import.meta.url),
  pt: new URL('/src/assets/img/opportunity-area/learn-more-web-pt.png', import.meta.url),
  ru: new URL('/src/assets/img/opportunity-area/learn-more-web-ru.png', import.meta.url),
  tr: new URL('/src/assets/img/opportunity-area/learn-more-web-tr.png', import.meta.url),
  gb: new URL('/src/assets/img/opportunity-area/learn-more-web-uk.png', import.meta.url),
}

const MOBILE_IMAGES = {
  us: new URL('/src/assets/img/opportunity-area/learn-more-mobile-us.png', import.meta.url),
  de: new URL('/src/assets/img/opportunity-area/learn-more-mobile-de.png', import.meta.url),
  br: new URL('/src/assets/img/opportunity-area/learn-more-mobile-br.png', import.meta.url),
  gr: new URL('/src/assets/img/opportunity-area/learn-more-mobile-el.png', import.meta.url),
  es: new URL('/src/assets/img/opportunity-area/learn-more-mobile-es.png', import.meta.url),
  fr: new URL('/src/assets/img/opportunity-area/learn-more-mobile-fr.png', import.meta.url),
  mx: new URL('/src/assets/img/opportunity-area/learn-more-mobile-mx.png', import.meta.url),
  it: new URL('/src/assets/img/opportunity-area/learn-more-mobile-it.png', import.meta.url),
  jp: new URL('/src/assets/img/opportunity-area/learn-more-mobile-ja.png', import.meta.url),
  nl: new URL('/src/assets/img/opportunity-area/learn-more-mobile-nl.png', import.meta.url),
  pl: new URL('/src/assets/img/opportunity-area/learn-more-mobile-pl.png', import.meta.url),
  pt: new URL('/src/assets/img/opportunity-area/learn-more-mobile-pt.png', import.meta.url),
  ru: new URL('/src/assets/img/opportunity-area/learn-more-mobile-ru.png', import.meta.url),
  tr: new URL('/src/assets/img/opportunity-area/learn-more-mobile-tr.png', import.meta.url),
  gb: new URL('/src/assets/img/opportunity-area/learn-more-mobile-uk.png', import.meta.url),
}

const getImage = type => {
  const images = type === 'web' ? WEB_IMAGES : MOBILE_IMAGES
  return images[langCode.value] || images.us
}

const modalTitle = 'rc_opportunities_top_position_info_header'
</script>
